<template>
  <div v-preventReclick class="c-app-side-action">
    <div class="action__button" @click="handleClick">
      <slot>
        <div class="action__icon flex-center">
          <div class="icon flex-center">
            <!-- <i v-bind="iconAttrs"></i> -->
            <img :src="iconAttrs" alt="icon" />
          </div>
        </div>
        <div class="action__label flex-center">{{ label }}</div>
      </slot>
    </div>

    <CAppSideDrawer v-if="drawer" ref="drawerRef" v-bind="innerDrawerAttrs" />

    <template v-if="CPluginComponent">
      <CPluginComponent />
    </template>
  </div>
</template>

<script setup lang="ts">
import { _, computed, onMounted, reactive, ref, watch, useHostAppInstance } from '@zto/zpage'
import { AppSideActionType } from './types'

const props = withDefaults(
  defineProps<{
    actionType?: AppSideActionType // 行为类型 （drawer）
    name?: string // 活动名称
    drawer?: any // drawer action
    event?: any // event action
    plugin?: string // 插件
    icon?: string | object
    label?: string
  }>(),
  {}
)

const app = useHostAppInstance()

const CAppSideDrawer = app.resolveComponent('CAppSideDrawer')

let CPluginComponent = props.plugin ? app.resolveComponent(props.plugin) : null

const drawerRef = ref<any>()

const iconAttrs = computed(() => {
  const icon = props.icon
  return icon
})

const innerActionType = computed(() => {
  if (props.actionType) return props.actionType

  if (props.drawer) return AppSideActionType.DRAWER
  if (props.event) return AppSideActionType.EVENT

  return AppSideActionType.CUSTOM
})

const innerDrawerAttrs = computed(() => {
  return { ...props.drawer }
})

function handleClick() {
  switch (innerActionType.value) {
    case AppSideActionType.DRAWER:
      openDrawer()
      break
    case AppSideActionType.EVENT:
      emitEvent()
      break
  }
}

// 打开抽屉
function openDrawer() {
  if (!drawerRef.value) return

  drawerRef.value.show()
}

// 发送事件
function emitEvent() {
  let event = props.event

  if (_.isString(event)) {
    event = { name: event }
  }

  if (!event) return

  event.source = 'app_side'

  app.emits(event.name as any, event)
}
</script>

<style lang="scss" scoped>
.c-app-side-action {
  .action {
    &__button {
      cursor: pointer;
    }

    &__icon {
      .icon {
        height: 28px;
        width: 28px;
        border-radius: 4px;
        background: white;
        img {
          width: 100%;
          height: 100%;
        }
        &:hover {
          background: hsla(0, 0%, 100%, 0.7);
        }
      }
    }

    &__label {
      font-size: 14px;
      margin-top: 8px;
      color: #121a44;
    }
  }
}
</style>
